import baseURL from "../common/axios";
class PackageMASservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("PackageMAS/Create", objinsert);
  }
  insertHMS(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("PackageMAS/HMSCreate", objinsert);
  }
  DeleteHMS(DelID, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "PackageMAS/HMSDelete?PackageId=" +
        DelID +
        "&HospitalId=" +
        HospitalId +
        ""
    );
  }
  //Active
  activeHMS(DelID, Status, HospitalId) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "PackageMAS/HMSActive?PackageId=" +
        DelID +
        "&Status=" +
        Status +
        "&HospitalId=" +
        HospitalId +
        ""
    );
  }
  UpdateHMS(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("PackageMAS/HMSUpdate", objupdate);
  }
  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("PackageMAS/List");
  }
  Edit(EditID) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("PackageMAS/Get?id=" + EditID + "");
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete("PackageMAS/Delete?id=" + DelID);
  }
  //Active
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "PackageMAS/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("PackageMAS/Update", objupdate);
  }
}
export default new PackageMASservices();
